module.exports = __webpack_public_path__ + "static/media/plus.54f64c36.svg";